import axios from 'axios';

// Base URLs from environment variables with fallbacks
const SERVICE_BASE_URLS = {
  vendor: process.env.REACT_APP_VENDOR_SERVICE_BASE_URL || 'http://203.161.55.192:8086',
  business: process.env.REACT_APP_BUSINESS_SERVICE_BASE_URL || 'http://203.161.55.192:8087',
  service: process.env.REACT_APP_ADD_SERVICE_BASE_URL || 'http://203.161.55.192:8089'
};

// Create a map of API clients for each service
const createApiClient = (baseURL) => {
  const client = axios.create({
    baseURL,
    timeout: 30000, // 30 seconds
    headers: {
      'Content-Type': 'application/json',
    },
  });

  // Request interceptor for adding auth token
  client.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem('token');
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  // Response interceptor
  client.interceptors.response.use(
    (response) => response,
    (error) => {
      // Only handle what must be handled globally (like 401)
      if (error.response?.status === 401) {
        localStorage.removeItem('token');
        // You might want to redirect to login here or let components handle it
      }
      
      // Let the component handle the rest
      return Promise.reject(error);
    }
  );

  return client;
};

// Create API clients for each service
const apiClients = {
  vendor: createApiClient(SERVICE_BASE_URLS.vendor),
  business: createApiClient(SERVICE_BASE_URLS.business),
  service: createApiClient(SERVICE_BASE_URLS.service)
};

// API endpoints organized by service and feature
const ENDPOINTS = {
  vendor: {
    register: '/vservice/api/v1/auth/vendor-register',
    resendotp:'/vservice/api/v1/auth/resend-otp',
    verifyregistered:'/vservice/api/v1/auth/vendor-verify',
    login: '/vservice/api/v1/auth/vendor-login',
    newpassword:'/vservice/api/v1/auth/vendor-reset-password',
    forgotpassword: '/vservice/api/v1/auth/vendor-forget-password',
    forgotpasswordotp: '/vservice//api/v1/auth/vendor-verify-otp',
    logout:'/vservice/api/v1/auth/vendor-signout'
  },
  business: {
    createbusiness: '/bservice/api/v1/auth/vendor-add-business-detail',
    vendorselectsubscription:'/bservice/api/v1/auth/vendor-select-subscription',
    showallsubscription:'/bservice/api/v1/auth/vendor-list-subscriptions',
    makepayment: '/bservice/api/v1/auth/initiate-transaction'
   
  },
  service: {
    addserviceinfo: '/addservice/api/v1/auth/vendor-add-service',
    // categories: '/addservice/api/v1/services/categories',
    // update: (id) => `/addservice/api/v1/services/${id}`,
  }
};

// Helper methods for making API requests
const api = {
  vendor: {
    get: async (endpoint, params = {}) => {
      try {
        const response = await apiClients.vendor.get(endpoint, { params });
        return response.data;
      } catch (error) {
        console.error(`Error getting from vendor service ${endpoint}:`, error);
        throw error;
      }
    },
    post: async (endpoint, data = {}) => {
      try {
        const response = await apiClients.vendor.post(endpoint, data);
        return response.data;
      } catch (error) {
        console.error(`Error posting to vendor service ${endpoint}:`, error);
        throw error;
      }
    },
    put: async (endpoint, data = {}) => {
      try {
        const response = await apiClients.vendor.put(endpoint, data);
        return response.data;
      } catch (error) {
        console.error(`Error updating at vendor service ${endpoint}:`, error);
        throw error;
      }
    },
    delete: async (endpoint) => {
      try {
        const response = await apiClients.vendor.delete(endpoint);
        return response.data;
      } catch (error) {
        console.error(`Error deleting from vendor service ${endpoint}:`, error);
        throw error;
      }
    }
  },
  business: {
    get: async (endpoint, params = {}) => {
      try {
        const response = await apiClients.business.get(endpoint, { params });
        return response.data;
      } catch (error) {
        console.error(`Error getting from business service ${endpoint}:`, error);
        throw error;
      }
    },
    post: async (endpoint, data = {}) => {
      try {
        const response = await apiClients.business.post(endpoint, data);
        return response.data;
      } catch (error) {
        console.error(`Error posting to business service ${endpoint}:`, error);
        throw error;
      }
    },
    put: async (endpoint, data = {}) => {
      try {
        const response = await apiClients.business.put(endpoint, data);
        return response.data;
      } catch (error) {
        console.error(`Error updating at business service ${endpoint}:`, error);
        throw error;
      }
    },
    delete: async (endpoint) => {
      try {
        const response = await apiClients.business.delete(endpoint);
        return response.data;
      } catch (error) {
        console.error(`Error deleting from business service ${endpoint}:`, error);
        throw error;
      }
    }
  },
  service: {
    get: async (endpoint, params = {}) => {
      try {
        const response = await apiClients.service.get(endpoint, { params });
        return response.data;
      } catch (error) {
        console.error(`Error getting from service API ${endpoint}:`, error);
        throw error;
      }
    },
    post: async (endpoint, data = {}) => {
      try {
        const response = await apiClients.service.post(endpoint, data);
        return response.data;
      } catch (error) {
        console.error(`Error posting to service API ${endpoint}:`, error);
        throw error;
      }
    },
    put: async (endpoint, data = {}) => {
      try {
        const response = await apiClients.service.put(endpoint, data);
        return response.data;
      } catch (error) {
        console.error(`Error updating at service API ${endpoint}:`, error);
        throw error;
      }
    },
    delete: async (endpoint) => {
      try {
        const response = await apiClients.service.delete(endpoint);
        return response.data;
      } catch (error) {
        console.error(`Error deleting from service API ${endpoint}:`, error);
        throw error;
      }
    }
  }
};

export { api, ENDPOINTS, SERVICE_BASE_URLS };